import React from 'react';
import { useParams } from 'react-router-dom';
import './DoctorsPage.css';

const DoctorDetailPage = ({ doctors }) => {
  const { id } = useParams();
  const allDoctors = Object.values(doctors).flat();
  const doctor = allDoctors.find((doc) => doc.id === parseInt(id));

  if (!doctor) {
    return <p>Doctor not found</p>;
  }

  return (
    <div className="doctor-detail-container">
      <div className="doctor-detail-header">
        <img src={doctor.image} alt={doctor.name} className="doctor-detail-image" />
        <div className="doctor-detail-info">
          <h1>{doctor.name}</h1>
          <div className="doctor-specialties">
  {doctor.specialties.map((specialty, index) => (
    <span key={index} className="specialty-badge">{specialty}</span>
  ))}
</div>
<div className="info-box">
  <h3>Experience</h3>
  <p>{doctor.experience} years of experience</p>
</div>
<div className="info-box">
  <h3>Achievements</h3>
  <p>{doctor.achievements}</p>
</div>

        </div>
      </div>
      <div className="doctor-full-bio">
        <h2>About Dr. {doctor.name}</h2>
        <p>{doctor.bio}</p>
        <p>{doctor.subBio}</p>
      </div>
    </div>
  );
};

export default DoctorDetailPage;
